<tellent-assistant-trigger
  [collapsed]="collapsed()"
  (triggered)="toggle()"
  (leave)="triggerLeave.emit($event)"
/>
